import { createSelector, createSlice } from "@reduxjs/toolkit";

const initialState = {

}

const remainderSlice = createSlice({
    name: 'remainderSlice',
    initialState,
    reducers: {
        fetchRemainder: (state, action) => {


        },
        updateReminder: (state, action) => {

        },
        fetchReport: (state, action) => { },
        deleteReminder: (state, action) => { }
    }
})

export const { fetchRemainder, updateReminder, deleteReminder, fetchReport } = remainderSlice.actions

export default remainderSlice.reducer